import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Clapperboard, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return "Terjadi kesalahan. Silakan coba lagi.";
}

export default function Register() {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Password dan konfirmasi tidak sama.");
      return;
    }
    setLoading(true);
    try {
      await register(name.trim(), email.trim(), password);
      toast.success("Akun berhasil dibuat");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-50">
      <div className="hidden lg:flex flex-col justify-between bg-blue-600 p-12 text-white">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/15">
            <Clapperboard className="h-5 w-5" />
          </div>
          <div>
            <p className="font-heading font-bold leading-tight">Mas Tofa AI</p>
            <p className="text-xs text-blue-100">AI Video Generator</p>
          </div>
        </div>
        <div>
          <h2 className="font-heading text-4xl font-bold leading-tight">Mulai Buat Video<br />Avatar AI Anda.</h2>
          <p className="mt-4 text-blue-100 max-w-sm">Daftar gratis dan buat video jualan hanya dari foto produk.</p>
        </div>
        <p className="text-xs text-blue-200">© Mas Tofa AI</p>
      </div>

      <div className="flex items-center justify-center p-6">
        <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-5" data-testid="register-form">
          <div>
            <h1 className="font-heading text-3xl font-bold text-slate-900">Daftar</h1>
            <p className="mt-1 text-slate-500">Buat akun baru Anda.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="name">Nama</Label>
            <Input id="name" data-testid="register-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Nama Anda" required />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" data-testid="register-email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nama@email.com" required />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" data-testid="register-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Minimal 6 karakter" required />
          </div>
          <div className="space-y-2">
            <Label htmlFor="confirm">Konfirmasi Password</Label>
            <Input id="confirm" type="password" data-testid="register-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Ulangi password" required />
          </div>
          <Button type="submit" data-testid="register-submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white active:scale-95 transition-transform">
            {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
            Daftar
          </Button>
          <p className="text-sm text-slate-500 text-center">
            Sudah punya akun?{" "}
            <Link to="/masuk" data-testid="go-login" className="font-medium text-blue-600 hover:underline">Masuk</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
